import React, { useState, useEffect } from "react";
import Dashboard from "../../layouts/Dashboard";
import Axios from "axios";
import url from "../../services/url";
import ClipboardJS from "clipboard/dist/clipboard";
import { useHistory } from "react-router-dom";

import LoadingArea from "../../components/LoadingArea";

function ApplicationList() {
  // States
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  // Use Effect
  useEffect(() => {
    new ClipboardJS(".btn-clipboard");
    loadApplicationList();
  }, []);

  // Functions
  function loadApplicationList(search = null) {
    let append = "";
    if (search !== null) {
      append = "?search=" + search;
    }
    setLoading(true);
    Axios.get(url("formtemplate" + append), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((result) => {
        setForms(result.data);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  }

  function onClickDeleteForm(event) {
    const form = event.target.getAttribute("form");
    Axios.delete(url("formtemplate/" + form))
      .then((res) => {
        if (res.data.deleted) {
          loadApplicationList();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function onClickEditForm(event) {
    const id = event.target.getAttribute("form");

    history.push("/application/edit/" + id);
  }

  function onClickSendEmail(event) {
    const form = event.target.getAttribute("form");
    const element = event.target.parentNode.parentNode.children[0];
    const email = element.value;
    let data = {
      email: email,
    };
    Axios.post(url("formtemplate/" + form + "/email"), data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((res) => {
        alert("Email was successfully sent.");
        element.value = "";
      })
      .catch((error) => {});
  }

  function onChangeSearch(event) {
    const searchTerm = event.target.value;
    if (searchTerm === "" || searchTerm.length >= 3) {
      loadApplicationList(searchTerm);
    }
  }

  return (
    <Dashboard title="Form Templates">
      <LoadingArea isLoading={loading}>
        <div className="row">
          <div className="card border-left-primary shadow h-100 py-2 w-100 mb-3">
            <div className="card-body">
              <input
                type="search"
                id="search"
                className="form-control mb-3"
                placeholder="Search for a form..."
                onChange={onChangeSearch}
              />
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-3 text-gray-800">
                    <table className="w-100 font-weight-bold">
                      <tbody>
                        <tr>
                          <td style={{ width: "20%" }}>Name</td>
                          <td style={{ width: "20%" }}>Form Link</td>
                          <td style={{ width: "60%" }}>Actions</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {forms.map((form) => (
            <div
              key={form._id}
              className="card border-left-primary shadow h-100 py-2 w-100 mb-3"
            >
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="h5 mb-3 text-gray-800">
                      <table className="w-100">
                        <tbody>
                          <tr>
                            <td style={{ width: "20%" }}>{form.name}</td>
                            <td style={{ width: "20%" }}>
                              <a
                                href={"/form/" + form._id}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ fontSize: "16px" }}
                              >
                                /form/{form._id}
                              </a>
                              <button
                                className="btn btn-primary btn-sm m-1 btn-clipboard"
                                data-clipboard-text={
                                  window.location.protocol +
                                  "//" +
                                  window.location.hostname +
                                  ":" +
                                  window.location.port +
                                  "/form/" +
                                  form._id
                                }
                              >
                                Copy
                              </button>
                            </td>
                            <td style={{ width: "40%" }}>
                              <div className="input-group">
                                <input
                                  className="form-control"
                                  type="email"
                                  id=""
                                />
                                <div className="input-group-append">
                                  <button
                                    className="btn btn-primary"
                                    form={form._id}
                                    onClick={onClickSendEmail}
                                  >
                                    Send Email
                                  </button>
                                </div>
                              </div>
                            </td>
                            <td style={{ width: "20%" }}>
                              <button
                                form={form._id}
                                onClick={onClickEditForm}
                                className="btn btn-warning mx-2"
                              >
                                Edit
                              </button>
                              <button
                                form={form._id}
                                onClick={onClickDeleteForm}
                                className="btn btn-danger mx-2"
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </LoadingArea>
    </Dashboard>
  );
}

export default ApplicationList;
